<template>
  <div class="news-list-container">
    <!-- 查询条件区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px" class="search-form">
      <el-form-item prop="title">
        <el-input v-model="queryParams.title" placeholder="新闻标题" clearable @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item prop="category">
        <el-select v-model="queryParams.category" placeholder="新闻分类" clearable>
          <el-option label="公司新闻" value="0"></el-option>
          <el-option label="行业资讯" value="1"></el-option>
          <el-option label="技术文章" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addNews">新增</el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table :data="tableData" border v-loading="loading">
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="category" label="分类" align="center" width="100px">
        <template slot-scope="{row}">
          <el-tag v-if="row.category == '0'" type="primary">公司新闻</el-tag>
          <el-tag v-else-if="row.category == '1'" type="success">行业资讯</el-tag>
          <el-tag v-else-if="row.category == '2'" type="warning">技术文章</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="isHot" label="热门" align="center" width="80px">
        <template slot-scope="{row}">
          <el-tag v-if="row.isHot == '1'" type="danger" size="small">热门</el-tag>
          <span v-else class="no-data">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="isTech" label="技术专栏" align="center" width="100px">
        <template slot-scope="{row}">
          <el-tag v-if="row.isTech=='1'" type="success" size="small">技术专栏</el-tag>
          <span v-else class="no-data">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="isTech" label="焦点新闻" align="center" width="100px">
        <template slot-scope="{row}">
          <el-tag v-if="row.isTop == '1'" type="success" size="small">焦点新闻</el-tag>
          <span v-else class="no-data">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="100px">
        <template slot-scope="{row}">
          <el-tag v-if="row.status === '1'" type="success" size="small">已发布</el-tag>
          <el-tag v-else-if="row.status === '0'" type="info" size="small">草稿</el-tag>
          <el-tag v-else type="info" size="small">{{ row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="180px"></el-table-column>
      <el-table-column label="封面图" align="center" width="100px">
        <template slot-scope="{row}">
          <el-image
            v-if="row.image"
            :src="row.image"
            fit="cover"
            class="table-image"
            :preview-src-list="[row.image]"
          ></el-image>
          <span v-else class="no-data">无</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="editRow(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="initData"
    />

  </div>
</template>

<script>
import { newsList, newsDelete } from "@/api/news.js";

export default {
  data() {
    return {
      queryParams: {
        title: '',
        category: ''
      },
      pageNum: 1,
      pageSize: 20,
      tableData: [],
      loading: false,
      total: 0,

    }
  },
  methods: {
    // 获取列表数据
    initData() {
      this.loading = true;
      let params = {
        model:{...this.queryParams},
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }
      newsList(this.queryParams).then(res => {
        this.tableData = res.data.data.records || [];
        this.total = res.data.data.total || 0;
        this.loading = false;
      }).catch(() => {
        this.$message.error('获取数据失败');
        this.loading = false;
      });
    },

    // 搜索
    search() {
      this.queryParams.pageNum = 1;
      this.initData();
    },

    // 重置查询
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },

    // 新增新闻
    addNews() {
      this.$router.push('/news/add');
    },

    // 编辑新闻
    editRow(row) {
      this.$router.push(`/news/edit/${row.id}`);
    },

    // 删除新闻
    deleteRow(id) {
      this.$confirm('确定要删除这条新闻吗？删除后将无法恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        newsDelete({ id }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('删除成功');
            this.initData();
          } else {
            this.$message.error(res.data.message || '删除失败');
          }
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

  },
  created() {
    this.initData();
  }
}
</script>

<style lang="less" scoped>
.news-list-container {
  padding: 20px;

  .search-form {
    margin-bottom: 20px;
  }

  
}

</style>
